import styled, { css } from "styled-components";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";
import { GamificationModalUserPhotoContainer } from "shared/components/molecules/Gamification/GamificationModal/atoms/UserPhoto/styles";
import { IllustrationContainerContainer } from "shared/components/organisms/AppNotification/components/atoms/IllustrationContainer/styles";
import { NotificationContainerWrapper } from "shared/components/organisms/AppNotification/components/atoms/NotificationContainer/styles";

import { ConsolePageButtonStyles } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";

export const SeeRankingButton = styled(ConsolePageButtonStyles)`
  padding: 0;

  margin: 12px 0;

  color: #000000;

  @media (max-width: 1366px) {
    width: 100%;
  }

  a {
    padding: 0.5rem 1rem;
  }
`;

const firstPlaceColor = "#ffcb4c";
const secondPlaceColor = "#c3cadc";
const thirdPlaceColor = "#e48720";

const podiumPlacesColors = [firstPlaceColor, secondPlaceColor, thirdPlaceColor];

const podiumColorsMap = [
  css`
    border-left: 2px solid ${firstPlaceColor};
    background: linear-gradient(
      90deg,
      rgba(255, 204, 77, 0.12) 0%,
      rgba(95, 73, 19, 0.12) 100%
    );
  `,
  css`
    border-left: 2px solid ${secondPlaceColor};
    background: linear-gradient(
      90deg,
      rgba(121, 128, 146, 0.12) 0%,
      rgba(43, 47, 56, 0.12) 100%
    );
  `,
  css`
    border-left: 2px solid ${thirdPlaceColor};
    background: linear-gradient(
      90deg,
      rgba(228, 135, 32, 0.12) 0%,
      rgba(102, 64, 22, 0.12) 100%
    );
  `,
];

interface IClimbedPodiumNotificationContainerProps {
  podiumPlace: number;
}

export const ClimbedPodiumNotificationContainer = styled.div<IClimbedPodiumNotificationContainerProps>`
  position: relative;
  overflow: hidden;

  > canvas {
    inset: initial !important;
    right: -160px !important;
    top: 0 !important;
    max-width: 272px;
    opacity: 0.5;

    @media (max-width: 1366px) {
      right: -166px !important;
    }
  }

  ${NotificationContainerWrapper} {
    ${({ podiumPlace }) => podiumColorsMap?.[podiumPlace]}

    grid-template-columns: auto 1fr auto;
  }

  .level-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    overflow: hidden;

    justify-content: flex-end;
  }

  ${IllustrationContainerContainer} svg path {
    fill: ${({ podiumPlace }) => podiumPlacesColors?.[podiumPlace]};
  }

  ${GamificationModalUserPhotoContainer} {
    margin-bottom: 0;
    z-index: 3;

    @media (max-width: 1366px) {
      .user-info {
        gap: 7px !important;
      }
    }

    ${SimpleUserInitialsNameContainer}, img {
      width: 56px !important;
      height: 56px !important;

      @media (max-width: 1366px) {
        width: 40px !important;
        height: 40px !important;

        h1 {
          font-size: 1rem;
        }
      }
    }

    .circular-progress {
      width: 67px !important;
      height: 67px !important;

      @media (max-width: 1366px) {
        width: 50px !important;
        height: 50px !important;
      }
    }

    .right-starts-icon,
    .left-starts-icon {
      width: 15px;
      height: 15px;
    }
  }

  .podium {
    z-index: 3;

    svg {
      width: ${({ podiumPlace }) =>
        podiumPlace === 1 ? "90px" : podiumPlace === 2 ? "100px" : "90px"};
      height: ${({ podiumPlace }) =>
        podiumPlace === 1 ? "70px" : podiumPlace === 2 ? "70px" : "100px"};
    }
  }

  ${SeeRankingButton} {
    background-color: ${({ podiumPlace }) => podiumPlacesColors?.[podiumPlace]};
  }
`;
